// extracted by mini-css-extract-plugin
export var loadingSpinner = "PageLoader-module--loading-spinner--fc318";
export var spin = "PageLoader-module--spin--6073a";